import { Listing } from '@smg-real-estate/hg-rets-schema';

import { isListingValidForUbsWidget } from './helper';

/**
 * Checks if the listing matches the specifications.
 */
export const isListingValidForUbsPreQualify = (listing: Listing): boolean => {
  const isValidZip = listing.address?.postalCode;
  const isValidCity = listing.address?.locality;
  const isValidListingId = listing.id;

  return isListingValidForUbsWidget(listing) && !!isValidZip && !!isValidCity && !!isValidListingId;
};
